import * as React from 'react';
const CheckInput = ({ width = 12, height = 10, color = 'white' }) => {
    return (React.createElement("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M1 5L3.2598 8.01307C3.64114 8.52152 4.39385 8.54988 4.81238 8.07157L11 1", stroke: color, strokeWidth: "2", strokeLinecap: "round" })));
};
export default CheckInput;
